document.querySelectorAll('.faq-table-format').forEach(wrapper => {
  const paragraphs = wrapper.querySelectorAll('p');
  const heading = wrapper.querySelectorAll('h3');

  const table = document.createElement('table');
  const tbody = document.createElement('tbody');

  paragraphs.forEach(p => {
    const row = document.createElement('tr');
    row.innerHTML = `<td>${p.innerHTML}</td>`;
    tbody.appendChild(row);
  });

  heading.forEach(h3 => {
    const row = document.createElement('tr');
    row.innerHTML = `<td>${h3.innerHTML}</td>`;
    tbody.appendChild(row);
  });

  table.appendChild(tbody);
  wrapper.innerHTML = '';
  wrapper.appendChild(table);
});

document.querySelectorAll('h3.faq-table-format').forEach(wrapper => {
  const questionHTML = wrapper.innerHTML.trim();

  const table = document.createElement('table');
  const tbody = document.createElement('tbody');
  const row = document.createElement('tr');

  row.innerHTML = `<td>${questionHTML}</td>`;
  tbody.appendChild(row);
  table.appendChild(tbody);

  wrapper.innerHTML = '';
  wrapper.appendChild(table);
});